var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{staticClass:"white lighten-1"})
}
var staticRenderFns = []

export { render, staticRenderFns }